// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"CopyButton_copyButton__3oJZ7","tooltip":"CopyButton_tooltip__2IXg5","textarea":"CopyButton_textarea__3M63Q"};